var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    `${_vm.$route.name}`,_vm.minwidth
],attrs:{"id":"app"}},[_c('router-view'),_c('div',_vm._l((_vm.coms),function(item,index){return _c(item,_vm._g(_vm._b({key:index,tag:"component"},'component',item.attrs,false),item.listeners),_vm._l((item.slots),function(ite,inde){return _c(ite,_vm._g(_vm._b({key:`${index}_${inde}`,tag:"component"},'component',ite.attrs,false),ite.listeners))}),1)}),1),_c('div',{class:_vm.bodyClass,staticStyle:{"display":"none"},attrs:{"id":"ksh34m2s"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }